var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPillBottle = function SvgPillBottle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C3.44772 1 3 1.44772 3 2L3 7.89998C3 8.45227 3.44772 8.89998 4 8.89998H5.0083L5.0083 22C5.0083 22.5523 5.45602 23 6.0083 23L18.0594 23C18.6117 23 19.0594 22.5523 19.0594 22L19.0594 8.89998H20C20.5523 8.89998 21 8.45227 21 7.89998V2C21 1.44772 20.5523 1 20 1L4 1ZM5 6.89998L5 3L8.44678 3V6.89998L5 6.89998ZM10.4468 6.89998V3L13.8936 3L13.8936 6.89998L10.4468 6.89998ZM15.8936 6.89998L19 6.89998V3L15.8936 3L15.8936 6.89998ZM7.0083 21L7.0083 9.10004L17.0594 9.10004L17.0594 21L7.0083 21Z",
    fill: "black"
  })));
};
export { SvgPillBottle as ReactComponent };
export default __webpack_public_path__ + "static/media/pill-bottle.80521331.svg";